import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  useIntl,
} from 'react-intl';
import { Field } from 'react-final-form';

import {
  Col,
  Select,
} from '@folio/stripes/components';

import {
  getDropdownOptionsUtils,
  handleFormDataChange,
} from '../../../utils';
import {
  ASSIGN_TO,
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
  TEAM,
  ASSIGNED_USER_ID_INITIAL_VALUE,
  ASSIGNED_USER_NAME_INITIAL_VALUE,
  TASK_ASSIGN_TO_FIELDS,
  TEAM_FIELDS,
} from '../../../constants';

const assignTo = [TASK_ASSIGN_TO_FIELDS.TEAM, TASK_ASSIGN_TO_FIELDS.USER];

const SelectAssignment = ({
  isObjectDataFormat,
  id,
  name,
  change,
  getTeams,
}) => {
  const intl = useIntl();

  const assignToOptions = useMemo(() => {
    return getDropdownOptionsUtils(`task.field.${ASSIGN_TO}`, assignTo);
  }, []);

  return (
    <Col
      data-test-assign-to
      sm={4}
    >
      <Field
        component={Select}
        id={id}
        label={<FormattedMessage id="ui-task-list.task.field.assignTo" />}
        name={name}
        placeholder={intl.formatMessage({ id: 'ui-task-list.task.field.selectAssignment.placeholder' })}
        type="text"
        onChange={(event) => {
          const value = event.target.value;

          let changeValues = {
            [ASSIGNED_USER_ID]: ASSIGNED_USER_ID_INITIAL_VALUE,
            [ASSIGNED_USER_NAME]: ASSIGNED_USER_NAME_INITIAL_VALUE,
            [ASSIGN_TO]: value,
          };

          if (value === TASK_ASSIGN_TO_FIELDS.USER) {
            changeValues = {
              ...changeValues,
              [TEAM]: {
                [TEAM_FIELDS.ID]: '',
                [TEAM_FIELDS.NAME]: '',
              },
            };

            handleFormDataChange(changeValues, isObjectDataFormat, change);
          } else {
            handleFormDataChange(changeValues, isObjectDataFormat, change);
            getTeams();
          }
        }}
      >
        {assignToOptions}
      </Field>
    </Col>
  );
};

SelectAssignment.propTypes = {
  change: PropTypes.func.isRequired,
  getTeams: PropTypes.func.isRequired,
  id: PropTypes.string,
  isObjectDataFormat: PropTypes.bool,
  name: PropTypes.string,
};

SelectAssignment.defaultProps = {
  isObjectDataFormat: false,
  id: ASSIGN_TO,
  name: ASSIGN_TO,
};

export default SelectAssignment;
